import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChatsService {

  chatRoomObsLength:Subject<any> = new Subject<any>();
  notificationsList:any[] = [];
  constructor() { }
}
